document.addEventListener("DOMContentLoaded", () => {
    // setTimeout(() => {
      const breadcrumb = document.querySelector('.breadcrumbs');
      const activeLink = document.querySelector(".mega-menu__link--active");
      let currentUrl = window.location.pathname;
      let isProductPage = currentUrl.includes("products") || false;
      if (!activeLink && !isProductPage)
      {         
        breadcrumb.setAttribute('style','display:block');
        return
      };
  
      const breadcrumbs = [{ name: "Home", url: "/" }];
      if(isProductPage){
        const productDataJsonScript = document.querySelector('script[data-product-json]');    
        let productDataJson = '';
        productDataJson = JSON.parse(productDataJsonScript.textContent);
        let brdCrmbUrl = "/collections/all-products";
        let brdCrmbName = "All Products";
        if(productDataJson.is_color){
          brdCrmbUrl = "/collections/colour";
         brdCrmbName = "All Colours"; 
        }
        breadcrumbs.push({
          name: brdCrmbName,
          url: brdCrmbUrl
        });
        if(productDataJson?.breadCrumbCollection !== null)
        {
          breadcrumbs.push({
            name: productDataJson?.breadCrumbCollection?.title,
            url: `/collections/${productDataJson?.breadCrumbCollection?.handle}`
          });
        }
        breadcrumbs.push({
          name: productDataJson?.title,
          url: `/products/${productDataJson?.handle}`
        });
      }
      else
      {
        // Try to find top-level parent menu
        const parentDetails = activeLink.closest(".mega-menu");
        if (parentDetails) {
          const topMenuLink = parentDetails.querySelector("summary a");
          if (topMenuLink) {
            const menuText = topMenuLink.querySelector(".menuText");
            const topMenuName = menuText ? menuText.textContent.trim() : topMenuLink.textContent.trim();
            breadcrumbs.push({
              name: topMenuName,
              url: topMenuLink.getAttribute("href")
            });
          }
        }

        // activeLink is your .mega-menu__link--active element
        const listItem = activeLink.closest("li"); // the <li> containing the active link
        let secondLevelMenu = null;

        // Go two levels up to find the parent <li> that contains the level-2 link
        if (listItem) {
          
          secondLevelMenu = listItem?.querySelector(".mega-menu__link--level-2");
          
          if(secondLevelMenu == null)
          {
            const parentLi = listItem.closest("ul")?.closest("li");
            secondLevelMenu = parentLi?.querySelector(".mega-menu__link--level-2");
          }
          if (secondLevelMenu && secondLevelMenu !== activeLink && !secondLevelMenu.classList.contains("mega-menu__link--active")) {
              const secondLevelMenuText = secondLevelMenu.querySelector(".menuText");
              const secondLevelMenuName = secondLevelMenuText
                  ? secondLevelMenuText.textContent.trim()
                  : secondLevelMenu.textContent.trim();
              breadcrumbs.push({
                  name: secondLevelMenuName,
                  url: secondLevelMenu.getAttribute("href"),
              });
          }
        }
    
        // Finally, add the active link
        const activeMenuText = activeLink.querySelector(".menuText");
        const activeMenuName = activeMenuText ? activeMenuText.textContent.trim() : activeLink.textContent.trim();
        breadcrumbs.push({
          name: activeMenuName,
          url: activeLink.getAttribute("href")
        });
      }

  
      const svgSeparator = `
        <li class="breadcrumbs__separator" aria-hidden="true">
          <span><svg width="4" height="8" viewBox="0 0 4 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0.137294 0.856044C0.320352 0.672985 0.617148 0.672985 0.800206 0.856044L3.61271 3.66854C3.79576 3.8516 3.79576 4.1484 3.61271 4.33146L0.800206 7.14396C0.617148 7.32701 0.320352 7.32701 0.137294 7.14396C-0.0457646 6.9609 -0.0457646 6.6641 0.137294 6.48104L2.61834 4L0.137294 1.51896C-0.0457646 1.3359 -0.0457646 1.0391 0.137294 0.856044Z"/>
          </svg></span>
        </li>
      `;
  
      let listElements = [];
      let jsonLDItems = [];
  
      breadcrumbs.forEach((item, index) => {
        const isLast = index === breadcrumbs.length - 1;
        if (index > 0) listElements.push(svgSeparator);
  
        if (!isLast) {
          listElements.push(`<li class="breadcrumbs__item"><a class="breadcrumbs__link" href="${item.url}">${item.name}</a></li>`);
        } else {
          listElements.push(`<li class="breadcrumbs__item" aria-current="page"><span>${item.name}</span></li>`);
        }
  
        jsonLDItems.push({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        });
      });
  
      const breadcrumbHTML = `
        <ol class="breadcrumbs__list page-width">${listElements.join('')}</ol>
        <script type="application/ld+json">
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": ${JSON.stringify(jsonLDItems, null, 2)}
        }
        </script>
      `;
        
      if (breadcrumb) {
        breadcrumb.innerHTML = '';
        breadcrumb.insertAdjacentHTML('beforeend', breadcrumbHTML);
        breadcrumb.setAttribute('style','display:block');
      }
    // }, 300);
  });
  